/* ===================================================================
   LIL' FOODEE — FOODEE FAM SIGNUP POPUP
   Vanilla JavaScript. No dependencies or private credentials.
   =================================================================== */
(function initPopup() {
  'use strict';

  /* Active Shopify discount verified in Admin on 7 August 2026. */
  var LF_DISCOUNT_CODE = 'FOODEEFAM';

  var SETTINGS = {
    openDelayMs: 8000,
    suppressDaysAfterClose: 14,
    suppressForeverAfterSignup: true,
    discount: {
      code: LF_DISCOUNT_CODE,
      shopOrigin: '',
      redirectPath: '/collections/all'
    }
  };

  var STORAGE_KEYS = {
    closedUntil: 'lf_foodee_fam_closed_until',
    subscribed: 'lf_foodee_fam_subscribed'
  };

  var KLAVIYO = {
    companyId: 'Y6DJYL',
    listId: 'T5ERXX',
    listName: 'Foodee Fam – Email Master',
    apiRevision: '2026-07-15',
    endpoint: 'https://a.klaviyo.com/client/subscriptions',
    customSource: 'Foodee Fam Website Popup',
    profileProperties: {
      '$source': 'Foodee Fam Website Popup',
      'LF Signup Source': 'website_popup',
      'LF Form Name': 'Foodee Fam Evergreen',
      'LF Offer Shown': 'early_access'
    },
    utmKeys: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
  };

  var overlay = document.getElementById('lf-popup');
  if (!overlay) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPopup, { once: true });
    }
    return;
  }

  if (overlay.getAttribute('data-lf-popup-initialized') === 'true') {
    return;
  }

  var frame = document.getElementById('lf-popup-frame');
  var closeBtn = document.getElementById('lf-popup-close');
  var signupState = document.getElementById('lf-popup-state-signup');
  var successState = document.getElementById('lf-popup-state-success');
  var form = document.getElementById('lf-popup-form');
  var emailInput = document.getElementById('lf-popup-email');
  var errorEl = document.getElementById('lf-popup-error');
  var submitBtn = document.getElementById('lf-popup-submit');
  var shopBtn = document.getElementById('lf-popup-shop');
  var codeValue = document.getElementById('lf-popup-code-value');
  var codeCopyBtn = document.getElementById('lf-popup-code-copy');
  var codeStatus = document.getElementById('lf-popup-code-status');

  /* Shopify can evaluate deferred theme assets before the snippet finishes parsing. */
  if (!frame || !closeBtn || !signupState || !successState || !form ||
      !emailInput || !errorEl || !submitBtn || !shopBtn || !codeValue ||
      !codeCopyBtn || !codeStatus) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPopup, { once: true });
    }
    return;
  }

  overlay.setAttribute('data-lf-popup-initialized', 'true');

  var openTimer = null;
  var closeTimer = null;
  var lastFocusedElement = null;
  var isOpen = false;

  /*
   * Preview-only test mode.
   * The flag works only when Shopify's unpublished-theme preview markers are
   * also present. It opens immediately, ignores suppression and never writes
   * suppression keys, so normal customer behaviour is unchanged.
   */
  function isPreviewTestMode() {
    try {
      var search = new URLSearchParams(window.location.search);
      var hasTestFlag = search.get('lf_popup_test') === '1';
      var isThemePreview = search.has('preview_theme_id') || search.has('_ab');
      var isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
      return hasTestFlag && (isThemePreview || isThemeEditor);
    } catch (error) {
      return false;
    }
  }

  var previewTestMode = isPreviewTestMode();

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      /* Storage can be unavailable; the signup still remains usable. */
    }
  }

  function isSuppressed() {
    if (previewTestMode) {
      return false;
    }

    if (SETTINGS.suppressForeverAfterSignup && storageGet(STORAGE_KEYS.subscribed) === 'true') {
      return true;
    }

    var closedUntil = parseInt(storageGet(STORAGE_KEYS.closedUntil) || '0', 10);
    return closedUntil > Date.now();
  }

  function suppressForDays(days) {
    storageSet(
      STORAGE_KEYS.closedUntil,
      String(Date.now() + days * 24 * 60 * 60 * 1000)
    );
  }

  function openPopup() {
    if (isOpen) {
      return;
    }

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    isOpen = true;
    lastFocusedElement = document.activeElement;
    overlay.hidden = false;

    window.requestAnimationFrame(function () {
      overlay.classList.add('is-open');
    });

    document.documentElement.classList.add('lf-popup-scroll-lock');
    document.addEventListener('keydown', onKeyDown);

    var focusTarget = successState.hidden ? emailInput : shopBtn;
    if (focusTarget) {
      focusTarget.focus({ preventScroll: true });
    }
  }

  function closePopup(options) {
    if (!isOpen) {
      return;
    }

    isOpen = false;
    var opts = options || {};

    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('lf-popup-scroll-lock');
    document.removeEventListener('keydown', onKeyDown);

    closeTimer = window.setTimeout(function () {
      overlay.hidden = true;
      closeTimer = null;
    }, 280);

    if (!previewTestMode && opts.remember !== false) {
      suppressForDays(SETTINGS.suppressDaysAfterClose);
    }

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }
  }

  var FOCUSABLE = 'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';

  function onKeyDown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    var nodes = Array.prototype.filter.call(
      frame.querySelectorAll(FOCUSABLE),
      function (element) {
        return element.offsetParent !== null;
      }
    );

    if (!nodes.length) {
      return;
    }

    var first = nodes[0];
    var last = nodes[nodes.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value).trim());
  }

  function showError(message) {
    errorEl.textContent = message;
    emailInput.classList.add('is-invalid');
    emailInput.setAttribute('aria-invalid', 'true');
  }

  function clearError() {
    errorEl.textContent = '';
    emailInput.classList.remove('is-invalid');
    emailInput.removeAttribute('aria-invalid');
  }

  function getUtmParameters() {
    var params = {};

    try {
      var search = new URLSearchParams(window.location.search);
      KLAVIYO.utmKeys.forEach(function (key) {
        var value = search.get(key);
        if (value) {
          params[key] = value;
        }
      });
    } catch (error) {
      /* Older browsers simply omit UTM properties. */
    }

    return params;
  }

  function submitToKlaviyo(email) {
    var profileProperties = Object.assign({}, KLAVIYO.profileProperties, getUtmParameters());
    profileProperties['LF Discount Code'] = SETTINGS.discount.code;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: KLAVIYO.customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: profileProperties,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: KLAVIYO.listId
            }
          }
        }
      }
    };

    return window.fetch(
      KLAVIYO.endpoint + '?company_id=' + encodeURIComponent(KLAVIYO.companyId),
      {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: KLAVIYO.apiRevision
        },
        body: JSON.stringify(payload)
      }
    ).then(function (response) {
      if (!response.ok) {
        throw new Error('Klaviyo rejected the subscription request with status ' + response.status + '.');
      }
      return response;
    });
  }

  function discountUrl() {
    var discount = SETTINGS.discount;
    return (discount.shopOrigin || '') + '/discount/' + encodeURIComponent(discount.code) +
      '?redirect=' + encodeURIComponent(discount.redirectPath);
  }

  function fillDiscount() {
    if (codeValue) {
      codeValue.textContent = SETTINGS.discount.code;
    }
    if (shopBtn) {
      shopBtn.setAttribute('href', discountUrl());
    }
  }

  function copyCode() {
    var code = SETTINGS.discount.code;
    var completed = false;

    function done() {
      if (completed) {
        return;
      }
      completed = true;

      if (!codeStatus || !codeCopyBtn) {
        return;
      }
      codeStatus.textContent = 'Copied — ' + code + ' is ready to paste.';
      codeCopyBtn.textContent = 'Copied';
      window.setTimeout(function () {
        codeCopyBtn.textContent = 'Copy';
      }, 2400);
    }

    function fallbackCopy() {
      var temp = document.createElement('textarea');
      temp.value = code;
      temp.setAttribute('readonly', '');
      temp.style.position = 'absolute';
      temp.style.left = '-9999px';
      document.body.appendChild(temp);
      temp.select();

      try {
        document.execCommand('copy');
        done();
      } catch (error) {
        if (codeStatus) {
          codeStatus.textContent = 'Copy didn’t work — the code is ' + code + '.';
        }
      }

      document.body.removeChild(temp);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      var fallbackTimer = window.setTimeout(fallbackCopy, 800);
      navigator.clipboard.writeText(code).then(function () {
        window.clearTimeout(fallbackTimer);
        done();
      }, function () {
        window.clearTimeout(fallbackTimer);
        fallbackCopy();
      });
    } else {
      fallbackCopy();
    }
  }

  function showSuccessState() {
    signupState.hidden = true;
    successState.hidden = false;
    fillDiscount();
    frame.setAttribute('aria-labelledby', 'lf-popup-heading-success');

    if (shopBtn) {
      shopBtn.focus({ preventScroll: true });
    }
  }

  function setSubmitting(isSubmitting) {
    submitBtn.disabled = isSubmitting;
    form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    submitBtn.textContent = isSubmitting ? 'Signing you up…' : 'Join the Foodee Fam';
  }

  function onSubmit(event) {
    event.preventDefault();
    var email = emailInput.value.trim();

    if (!email) {
      showError('Pop your email in first.');
      emailInput.focus();
      return;
    }

    if (!isValidEmail(email)) {
      showError('That email doesn’t look quite right — mind checking it?');
      emailInput.focus();
      return;
    }

    clearError();
    setSubmitting(true);

    submitToKlaviyo(email)
      .then(function () {
        if (!previewTestMode) {
          storageSet(STORAGE_KEYS.subscribed, 'true');
        }
        showSuccessState();
      })
      .catch(function () {
        showError('We couldn’t sign you up right now. Please check your connection and try again.');
        emailInput.focus();
      })
      .then(function () {
        setSubmitting(false);
      });
  }

  closeBtn.addEventListener('click', function () {
    closePopup();
  });

  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) {
      closePopup();
    }
  });

  if (codeCopyBtn) {
    codeCopyBtn.addEventListener('click', copyCode);
  }

  if (shopBtn) {
    shopBtn.addEventListener('click', function () {
      if (!previewTestMode) {
        storageSet(STORAGE_KEYS.subscribed, 'true');
      }
    });
  }

  fillDiscount();

  form.addEventListener('submit', onSubmit);
  emailInput.addEventListener('input', clearError);

  if (previewTestMode) {
    openPopup();
  } else if (!isSuppressed()) {
    openTimer = window.setTimeout(openPopup, SETTINGS.openDelayMs);
  }

  window.LilFoodeePopup = {
    open: openPopup,
    close: closePopup,
    showSuccess: showSuccessState,
    submitToKlaviyo: submitToKlaviyo,
    settings: SETTINGS
  };
})();
